<div class="searchbox-container">
    @if (!loading) {
        <fa-icon
            class="search-advanced-mobile"
            [icon]="['fas', 'sliders-h']"
            (click)="openAdvanceSearch()"
        ></fa-icon>
    } @if (loading) {
        <fa-icon [icon]="['fas', 'spinner']" [pulse]="true"></fa-icon>
    }

    <mat-select
        class="select-search chevron-arrow"
        placeholder="Select Location"
        [matMenuTriggerFor]="menu"
        hideSingleSelectionIndicator
        #menuTrigger
    ></mat-select>
    <mat-menu #menu="matMenu" class="advanced-search-location-menu">
        <div class="pop-over-location" (click)="$event.stopPropagation()">
            <input
                #zipCodeInput
                type="text"
                class="location-zip-code-field"
                placeholder="Zip Code"
                [(ngModel)]="zipcode"
                (click)="$event.stopPropagation()"
            />

            @if (distances) {
                <mat-select
                    class="select-search"
                    placeholder="Select Within"
                    [(ngModel)]="distance"
                    (selectionChange)="onLocationChange($event.value)"
                    (click)="$event.stopPropagation()"
                    hideSingleSelectionIndicator
                >
                    @for (location of distances; track location) {
                        <mat-option [value]="location.value">
                            {{ location.name }}
                        </mat-option>
                    }
                </mat-select>
            }
        </div>
    </mat-menu>

    @if (divText) {
        <div class="div-text">{{ divText }}</div>
    } @if (categories) {
        <mat-select
            class="select-search chevron-arrow"
            placeholder="Select Category"
            (selectionChange)="onCategoryChange($event.value)"
            [formControl]="formControl"
            panelClass="ras-select-panel"
            hideSingleSelectionIndicator
        >
            @for (category of categories; track category) {
                <mat-option [value]="category.name">{{ category.name }}</mat-option>
            }
        </mat-select>
    }
    <input
        #zipCodeInput
        ac-keydown
        type="text"
        [placeholder]="configuration.placeholder"
        [formControl]="formControl"
        [matAutocomplete]="auto"
        autocomplete="off"
        (keyup.escape)="zipCodeInput.blur(); clearControl()"
    />

    <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="onSelect($event)"
        [displayWith]="displayValue"
        class="search-autocomplete"
    >
        @if (options && options.length) {
            @for (group of options; track group) {
                <mat-optgroup [label]="getGroupLabel(group[0].key) + ':'">
                    @for (option of group; track tracker($index, option)) {
                        <mat-option [value]="option" class="ras-searchbox-item">
                            <div class="option-value">
                                @if (configuration.icons[ option.key ]) {
                                    <fa-icon
                                        [icon]="['fas', configuration.icons[option.key]]"
                                    ></fa-icon>
                                }
                                <span
                                    class="result-field-value"
                                    [innerHTML]="option.label"
                                ></span>
                            </div>
                            @if (option.count) {
                                <span class="option-count">{{ option.count }}</span>
                            }
                        </mat-option>
                    }
                </mat-optgroup>
            }
        } @if (options && !options.length && searchText) {
            <mat-option disabled [innerHTML]="configuration.noResults"></mat-option>
        }
    </mat-autocomplete>
    @if (configuration.inlineStyles) {
        <div ras-inject-content [styles]="configuration.inlineStyles"></div>
    }
</div>
